// Restaurant industry tokens. "Epicurean editorial" look (Stitch: Gourmet
// Heritage): warm parchment surface, toasted-amber primary, heritage crimson
// accent, Playfair Display headlines over Plus Jakarta Sans UI, soft radii.
import { baseTokens } from '../_base/tokens.js';

export const restaurantTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#b45309',
    colorInfo: '#b45309',
    colorLink: '#b45309',
    colorPrimaryHover: '#903f00',
    colorLinkHover: '#903f00',
    colorPrimaryActive: '#763300',
    colorWarning: '#f7be1d',
    colorError: '#ba1a1a',
    borderRadius: 12,
    colorBgLayout: '#fdf9f3',
    colorTextBase: '#1c1c18',
    fontFamily:
      "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    ...baseTokens.components,
    Button: { borderRadius: 999, fontWeight: 600 },
  },
};
